import React from "react";
import { pure } from "recompose";

import Goal from "./Goal";

const CEOGoals = pure(({ team }) => (
  <Goal
    name="Financial Projections"
    checked={team.projections_submitted === true ? true : null}
  />
));

export default CEOGoals;



// WEBPACK FOOTER //
// ./src/components/dashboard/CEOGoals.js